'use strict';

angular.module('atex.dam').controller('DamEditCropController', ['$scope',
function($scope) {

  $scope.panelTitle = 'Edit Crop';

  $scope.loaded = false;
  $scope.showSpinner = true;

  $scope.template = {
    "aspects": {
      "atex.Files": {},
      "atex.ImageEditInfo": {},
      "atex.Image": {}
    },
    "dataBindings": [
      {
        "widget": "pImageEditor",
        "domainObjects": {
          "files": ["atex.Files"],
          "editInfo": ["atex.ImageEditInfo"],
          "image": ["atex.Image"]
        }
      }
    ]
  };
  $scope.loaded = true;

  $scope.hideSpinner = function() {
    $scope.showSpinner = false;
  };

  $scope.doSave = function() {
    $scope.$parent.closeModal($scope.article);
  };

  $scope.changeEndCallback = function(data) {
    $scope.article.data = data;
    $scope.dirty = true;
  };

} ]);
